import { useEffect } from "react";
import { Box, Card, Divider, Snackbar, Typography, useTheme } from "@mui/material";
import { AavoToastContext } from "./context";
import { CancelButton } from "../buttons/CancelButton";
import { AavoViewsContext } from "../../views/legacy/aavoViewsContext";
import { AavoToastContent } from "./types";
import { isOpenToastEvent, SHOW_TOAST_EVENT_ACTION_SPECIFIER, ViewActionEvent } from "../../views/legacy/events";
import { primitiveToString } from "src/types/primitive.ts";

import { useContextOrThrow } from "src/utils/useContextOrThrow.tsx";

export const AavoToast = () => {
    const {state, dispatch} = useContextOrThrow(AavoToastContext);
    const {state: aavoViewsState} = useContextOrThrow(AavoViewsContext);
    const theme = useTheme();

    useEffect(() => {
        aavoViewsState.viewActionEvents.events.forEach((e) => {
            if (isOpenToastEvent(e)) {
                dispatch({
                    type: "displayContent",
                    payload: getToastContentFromEvent(e)
                });
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [aavoViewsState.viewActionEvents]);
    return <Snackbar
        open={state.open}
        onClose={() => {
            dispatch({type: "closeToast"});
        }}
        anchorOrigin={{
            vertical: "bottom",
            horizontal: "center"
        }}
        sx={{
            maxWidth: "60vw"
        }}
        autoHideDuration={3000}
    >
        <Card
            sx={{
                padding: 2,
                display: "flex",
                flexDirection: "column"
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    flex: 1,
                    justifyContent: "space-between",
                    alignItems: "center",
                    paddingBottom: 1
                }}
            >
                <Typography variant={"h6"} color={theme.palette.info.main}>
                    {state.title}
                </Typography>
                <CancelButton
                    sx={{
                        padding: 0
                    }}
                    onClick={() => {
                        dispatch({type: "closeToast"});
                    }}
                />
            </Box>
            <Divider/>
            <Typography
                sx={{
                    paddingTop: 1,
                    wordWrap: "break-word"
                }}
                color={theme => theme.palette.grey[600]}
            >
                {state.message}
            </Typography>
        </Card>
    </Snackbar>
};

const TOAST_TITLE_PARAM_KEY = "__MSG_TITLE__";
const TOAST_MSG_PARAM_KEY = "__MSG_CONTENT__";
const getToastContentFromEvent = (e: ViewActionEvent): AavoToastContent => {
    const titleParam = e.allParams.find((param) => {
        return param.key === TOAST_TITLE_PARAM_KEY;
    });
    const msgParam = e.allParams.find((param) => {
        return param.key === TOAST_MSG_PARAM_KEY;
    });
    if (titleParam === undefined || msgParam === undefined) {
        throw Error(
            `${SHOW_TOAST_EVENT_ACTION_SPECIFIER} action event did not contain ${TOAST_TITLE_PARAM_KEY} or ${TOAST_MSG_PARAM_KEY} parameters.`
        );
    }
    return {
        title: primitiveToString(titleParam.value),
        message: primitiveToString(msgParam.value)
    };
};
